<template>
  <div id="user">
    <div class="usercon">
      <span class="user_errcode" v-show="errcode != ''">错误消息：{{errcode}}</span>
      <div class="user_box">
        <span class="user_title">手机：</span><span>{{$store.state.phone}}</span><span> (登入账号)</span>
      </div>
      <div class="user_box">
        <div v-if="$store.state.changed != 0">
          <span class="user_title">昵称：</span><span>{{$store.state.username}}</span>
        </div>
        <div v-else>
          <span class="user_title">昵称：</span>
          <span style="display: inline-block;;width:300px;">
            <el-input
              type="text"
              placeholder="请输入内容"
              v-model="dusername"
              maxlength="25"
              show-word-limit
              size="medium"
              @blur="nameinputblur"
            ></el-input>
          </span>
          <span class="user_usernameok">
            <el-button type="primary" @click.stop="usernameclick($store.state.phone)" size="medium">提交昵称</el-button>
          </span>
          <span class="tschangeusername">昵称只能修改一次</span>
        </div>
      </div>
      <div class="user_box">
        <span class="user_title">修改密码：</span>
        <span style="display: inline-block;;width:300px;">
          <el-input placeholder="请输入密码" @blur="password1blur" v-model="dpassword1" show-password :disabled="$store.state.passchanged!=0"></el-input>
        </span>
        <span class="tschangeusername">密码一月只能修改一次 当前剩余{{$store.state.passchanged==0?1:0}}/1</span>
      </div>
      <div class="user_box">
        <span class="user_title">再次输入：</span>
        <span style="display: inline-block;;width:300px;">
          <el-input placeholder="再次输入密码" @blur="password2blur" v-model="dpassword2" show-password :disabled="$store.state.passchanged!=0"></el-input>
        </span>
        <span v-if="$store.state.passchanged == 0" class="user_passwordok">
          <el-button type="primary" size="medium" @click.stop="cpasswordclick($store.state.phone)">提交密码</el-button>
        </span>
      </div>
      <div class="user_box">
        <span class="user_title">账户类型：</span><span>{{$store.state.role==0?'会员':'超级会员'}}</span>
      </div>
      <div class="user_box">
        <span class="user_title">插件载入功能：</span><span class="user_lang">{{$store.state.sqlgrid}} </span>
        <span class="user_sqlgrid_sm"> 【
          <span @click.stop="user_signinclick">每日签到</span>、
          <el-tooltip class="item" effect="dark" content="在插件端可实现一键上传" placement="bottom">
            <span>上传素材</span>
          </el-tooltip>、
          <router-link class="user_routerlink" to="/users/ifriend">邀请好友</router-link>、
          <router-link class="user_routerlink" to="/users/support">支持我们</router-link>获取
          】</span>
        <span class="tschangesqlgrid">
          <p>此值说明：</p>
          <p>1.会员拥有预支功能 最大可至-{{$store.state.system_advance_sqlgrid}}</p>
          <p>2.此值发生变更时会在客户端触发通知告知（除非未运行客户端）</p>
          <p>3.在网页中每点击一次素材中的此功能会预先检查本地库是否存在相关素材，如存在，则不会减少此值。如不存在，则会查找使用此素材记录，如有，则不会减少此值。</p>
          <p>4.所有素材触发此值减分都按模型-30、材质-20、贴图-10计算</p>
          <p>建议：</p>
          <p>作图过程中想找素材时直接使用本网页查找，放心用，随意用，所见即得。也是开发者的初衷。</p>
        </span>
      </div>
      
    </div>
  </div>
</template>

<script>
import {setusername,cpassword} from 'network/users.js'

export default {
  name:'user',
  data() {
    return {
      dusername:'',
      dpassword1:'',
      dpassword2:'',
      errcode:'',
    }
  },
  methods: {
    nameinputblur(){
      const nameReg=/^[a-zA-Z_\u4e00-\u9fa5][a-zA-Z0-9_\u4e00-\u9fa5]{1,24}$/
      if (!nameReg.test(this.dusername)) {
        this.errcode = '昵称由1-25位数字、字母、汉字或者下划线组成，首位非数字'
      }else{
        this.errcode = ''
      }
    },
    password1blur(){
      const passwordReg=/^[~!@#$%^&*\-+=_.0-9a-zA-Z]{6,16}$/
      if (!passwordReg.test(this.dpassword1)) {
        this.errcode = '密码由6-16位数字、字母和一些特殊字符组成'
      }else{
        this.errcode = ''
      }
    },
    password2blur(){
      if (this.dpassword1 != this.dpassword2) {
        this.errcode = '两次输入的密码必须相同'
      }else{
        this.errcode = ''
      }
    },
    // 签到点击
    user_signinclick(){
      this.$store.state.userpanelshow = false
      if(this.$store.state.username){
        this.cause = ""
        this.$store.state.signinVisible = true
      }else{
        this.$store.state.reg_logVisible = true
        this.cause = '签到功能需要账号支持 请先登入'
      }
    },
    // 点击修改昵称
    usernameclick(phone){
      const nameReg=/^[a-zA-Z_\u4e00-\u9fa5][a-zA-Z0-9_\u4e00-\u9fa5]{1,24}$/
      if (!nameReg.test(this.dusername)) {
        this.$elMessage('昵称由1-25位数字、字母、汉字或者下划线组成，首位非数字','error')
        return
      }
      setusername(this.dusername,phone).then(res=>{
        // console.log(res);
        if(res.state == 0){
          this.$store.state.username=this.dusername
          this.$store.state.changed=1
          //获取上一次登入的用户
          try{
            const yh = JSON.parse(this.utils.decrypt(localStorage.getItem('webyh')))
            if(Object.keys(yh).length >0){
              yh.name = this.dusername
              yh.changed = 1
              localStorage.setItem('webyh',this.utils.encrypt(JSON.stringify(yh)))
            }
          }catch(e){}
        }else{
          this.$elMessage('昵称修改失败','error')
        }
      })
    },
    cpasswordclick(phone){
      const passwordReg=/^[~!@#$%^&*\-+=_.0-9a-zA-Z]{6,16}$/
      if (!passwordReg.test(this.dpassword1)) {
        this.$elMessage('密码由6-16位数字、字母和一些特殊字符组成','error')
        return
      }
      if (this.dpassword1 != this.dpassword2) {
        this.$elMessage('两次输入的密码必须相同','error')
        return
      }
      cpassword(this.dpassword1,phone).then(res=>{
        console.log(res);
        if(res.state == 0){
          this.$store.state.passchanged=1
          //获取上一次登入的用户
          try{
            const yh = JSON.parse(this.utils.decrypt(localStorage.getItem('webyh')))
            if(Object.keys(yh).length >0){
              yh.passchanged = 1
              localStorage.setItem('webyh',this.utils.encrypt(JSON.stringify(yh)))
            }
          }catch(e){}
          localStorage.setItem('loginpassword',this.utils.encrypt(this.dpassword1))
          this.$elMessage('密码修改成功，欢迎下次使用新密码登入。','success')
        }else{
          this.$elMessage('密码修改失败','error')
        }
      })
    }
  },
  created() {
    this.dusername = this.$store.state.username
  },
  beforeRouteEnter(to,from,next){
    next(vm=>{
      if(!vm.$store.state.username){
        vm.$router.push('/home')
        vm.$store.state.reg_logVisible = true
      }
    })
  }
}
</script>

<style>
#user{
  flex: 1;
  overflow-y: scroll;
  padding: 50px;
  position: relative;
}
.usercon{
  width: 100%;
  font-size: 14.5px;
}
.user_errcode{
  position: absolute;
  top:50px;
  left: 120px;
  color:#f40;
  font-size: 12px;
}
.user_box{
  margin: 30px 0;
  position: relative;
}
.user_title{
  display: inline-block;
  width: 130px;
  text-align: right;
}
.tschangeusername{
  position: absolute;
  bottom:-20px;
  left: 130px;
  font-size: 13px;
  color: rgb(136, 142, 146);
}
.user_lang{
  color: var(--color-high-text);
}
.user_passwordok,.user_usernameok{
  margin-left: 15px;
}
.user_sqlgrid_sm{
  color: rgb(136, 142, 146);
}
.user_sqlgrid_sm span,.user_routerlink{
  color: var(--color-high-text);
  cursor: pointer;
}
.user_sqlgrid_sm span:hover,.user_routerlink:hover{
  color: #3b4553;
}
.tschangesqlgrid{
  position: absolute;
  top:20px;
  left: 130px;
  display: flex;
  flex-flow:column nowrap;
}
.tschangesqlgrid p{
  margin: 5px 0;
  width: 500px;
  line-height: 20px;
  letter-spacing:1px;
  font-size: 13px;
}
</style>